// extracted by mini-css-extract-plugin
export default {"background":"ExternalLinkIcon_background__n-4+U"};